var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#FB7C2F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 31,
    height: 31,
    fill: "#D9D9D9",
    stroke: "#FB7C2F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8321 34.682L23.9115 36.6294C23.7162 36.7164 23.5052 36.8139 23.2785 36.9219C23.044 37.0336 22.8591 37.1679 22.7244 37.325L22.7176 37.333L22.7241 37.3411C22.8703 37.5209 23.1111 37.6886 23.4452 37.8445C23.7795 38.0005 24.2081 38.1452 24.7308 38.2786C25.7763 38.5456 26.8662 38.679 28.0005 38.679C29.1348 38.679 30.2303 38.5456 31.2869 38.2786C31.8151 38.1452 32.2479 38.0005 32.5849 37.8445C32.9218 37.6886 33.164 37.5209 33.3102 37.3411L33.3169 37.3329L33.3099 37.3249C33.153 37.1457 32.9515 37.0002 32.7057 36.8885C32.4676 36.7803 32.2401 36.6826 32.0231 36.5954L34.0691 34.6154C34.6862 34.9691 35.1598 35.3721 35.4904 35.8239C35.8222 36.2773 35.988 36.7803 35.988 37.3332C35.988 38.5043 35.2482 39.462 33.7616 40.2053C32.275 40.9486 30.3549 41.3207 28.0005 41.3207C25.6461 41.3207 23.726 40.9486 22.2394 40.2053C20.7528 39.462 20.013 38.5043 20.013 37.3332C20.013 36.8025 20.1732 36.3106 20.494 35.8571C20.8136 35.4053 21.2594 35.0136 21.8321 34.682ZM28.0261 34.0096L28.0336 34.0156L28.0413 34.0099C30.242 32.3871 31.8987 30.7584 33.0108 29.1235C34.1231 27.4886 34.6797 25.8473 34.6797 24.1998C34.6797 21.9303 33.9564 20.2152 32.5083 19.0567C31.0621 17.8998 29.5594 17.3207 28.0005 17.3207C26.4416 17.3207 24.9389 17.8998 23.4927 19.0567C22.0446 20.2152 21.3213 21.9303 21.3213 24.1998C21.3213 25.6919 21.867 27.2443 22.9568 28.8568C24.0467 30.4694 25.7366 32.187 28.0261 34.0096ZM28.0005 37.3176C24.8715 35.0089 22.5362 32.7672 20.994 30.5926C19.4507 28.4164 18.6797 26.2855 18.6797 24.1998C18.6797 22.6236 18.9627 21.2421 19.5285 20.0552C20.0945 18.8677 20.8213 17.8746 21.7089 17.0758C22.5966 16.2769 23.5952 15.6777 24.7047 15.2783C25.8146 14.8787 26.9132 14.679 28.0005 14.679C29.0878 14.679 30.1864 14.8787 31.2963 15.2783C32.4058 15.6777 33.4044 16.2769 34.2921 17.0758C35.1797 17.8746 35.9065 18.8677 36.4726 20.0552C37.0383 21.2421 37.3213 22.6236 37.3213 24.1998C37.3213 26.2855 36.5503 28.4164 35.007 30.5926C33.4648 32.7672 31.1295 35.0089 28.0005 37.3176ZM29.875 25.8743C29.3551 26.3942 28.7305 26.654 28.0005 26.654C27.2705 26.654 26.6459 26.3942 26.126 25.8743C25.6061 25.3544 25.3463 24.7298 25.3463 23.9998C25.3463 23.2698 25.6061 22.6452 26.126 22.1253C26.6459 21.6054 27.2705 21.3457 28.0005 21.3457C28.7305 21.3457 29.3551 21.6054 29.875 22.1253C30.3949 22.6452 30.6547 23.2698 30.6547 23.9998C30.6547 24.7298 30.3949 25.3544 29.875 25.8743Z",
    fill: "#FB7C2F",
    stroke: "#FB7C2F",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.08377df3e472cc497d29a6f38cab6c21.svg";
export { ForwardRef as ReactComponent };